import rhinoCore from 'rhino/src/core/core.module';
import * as rnFeatureService from './feature.service';

export default angular.module('rhino.components.feature', [
  rhinoCore
])
  .service(rnFeatureService.name, rnFeatureService.default)
  .name;



// WEBPACK FOOTER //
// ../~/@printos/rhino/src/components/feature/feature.module.js